import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ChangeAmountModal.css';

const ChangeAmountModal = ({ isOpen, onClose, request, onSubmit }) => {
    const { t } = useTranslation('forms');
    const [newAmount, setNewAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (request && isOpen) {
            // Предзаполняем текущей суммой
            // Если payment_amount_info содержит HTML, берём только числовую часть
            let amountStr = request.payment_amount || request.payment_amount_info || '';
            if (typeof amountStr === 'string') {
                // Извлекаем только числа и точки
                amountStr = amountStr.replace(/<[^>]*>/g, '').replace(/[^\d.]/g, '');
            }
            setNewAmount(amountStr.toString().replace(/\s/g, ''));
            setError(null);
        }
    }, [request, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newAmount || parseFloat(newAmount) <= 0) {
            setError(t('forms:changeAmount.amountMustBePositive'));
            return;
        }

        setLoading(true);
        setError(null);

        try {
            await onSubmit(request.pk, parseFloat(newAmount));
            setNewAmount('');
        } catch (err) {
            setError(t('forms:changeAmount.changeError'));
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="change-amount-modal-overlay" onClick={onClose}>
            <div className="change-amount-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="change-amount-modal-header">
                    <h2>✏️ {t('forms:changeAmount.title')}</h2>
                    <button className="change-amount-modal-close" onClick={onClose}>✕</button>
                </div>

                <form onSubmit={handleSubmit} className="change-amount-modal-form">
                    <div className="change-amount-modal-info">
                        <div className="change-amount-info-row">
                            <label>{t('forms:changeAmount.requestId')}</label>
                            <span className="change-amount-info-value">{request?.pk}</span>
                        </div>

                        <div className="change-amount-info-row">
                            <label>{t('forms:changeAmount.currentAmount')}</label>
                            <span className="change-amount-info-value">
                                {request?.payment_amount_info ?
                                    request.payment_amount_info.replace(/<[^>]*>/g, '')
                                    : ''}
                            </span>
                        </div>

                        <div className="change-amount-info-row">
                            <label>{t('forms:changeAmount.status')}</label>
                            <span className="change-amount-info-value">{request?.status_display || request?.status}</span>
                        </div>

                        {request?.client_requisites && (
                            <div className="change-amount-info-row">
                                <label>{t('forms:changeAmount.clientRequisites')}</label>
                                <span className="change-amount-info-value">{request.client_requisites}</span>
                            </div>
                        )}
                    </div>

                    <div className="change-amount-modal-input-group">
                        <label htmlFor="newAmount">{t('forms:changeAmount.newAmount')}</label>
                        <input
                            id="newAmount"
                            type="number"
                            step="0.01"
                            min="0"
                            value={newAmount}
                            onChange={(e) => {
                                setNewAmount(e.target.value);
                                setError(null);
                            }}
                            placeholder={t('forms:changeAmount.newAmountPlaceholder')}
                            disabled={loading}
                            required
                            className="change-amount-modal-input"
                        />
                    </div>

                    {error && (
                        <div className="change-amount-modal-error">
                            ⚠️ {error}
                        </div>
                    )}

                    <div className="change-amount-modal-warning">
                        ℹ️ {t('forms:changeAmount.warning')}
                    </div>

                    <div className="change-amount-modal-actions">
                        <button
                            type="submit"
                            className="change-amount-modal-btn change-amount-modal-btn-submit"
                            disabled={loading}
                        >
                            {loading ? t('common:loading') : '✓ ' + t('common:confirm')}
                        </button>
                        <button
                            type="button"
                            className="change-amount-modal-btn change-amount-modal-btn-cancel"
                            onClick={onClose}
                            disabled={loading}
                        >
                            ✕ {t('common:cancel')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangeAmountModal;
